import React from 'react';
import { Link } from 'react-router-dom';
import '../css/HomePage.css';

const HomePage = () => (
  <div className="home-page">
    {/* Hero Section */}
    <section className="hero">
      <h1>Reunite What Matters. Fast.</h1>
      <p>
        A community-driven way to match lost and found items using smart search,
        visual similarity and real-time alerts — so good people can help each
        other faster.
      </p>
      <div className="hero-buttons">
         <span className="slider" />
        <Link to="/lost-items" className="btn btn-primary">Find Lost Items</Link>
        <Link to="/new-item" className="btn btn-outline-primary">Report Lost/Found</Link>
      </div>
    </section>

    {/* How It Works */}
    <section className="features">
      <h2>How It Works</h2>
      <div className="features-grid">
        <div className="feature-card">
          <h3>🔍 Smart Search</h3>
          <p>Filter by location, date and item type to pinpoint results in seconds.</p>
        </div>
        <div className="feature-card">
          <h3>📸 Visual Match</h3>
          <p>Upload a photo and see visually similar items suggested instantly.</p>
        </div>
        <div className="feature-card">
          <h3>✉️ Real‑time Alerts</h3>
          <p>Get notified the moment a new match appears — no constant refreshing.</p>
        </div>
        <div className="feature-card">
          <h3>🤝 Safe Messaging</h3>
          <p>Coordinate returns inside the app without sharing personal numbers.</p>
        </div>
      </div>
    </section>

    {/* Statistics Section */}
    <section className="statistics">
      <h2>Our Impact</h2>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>10,000+</h3>
          <p>Items Reunited</p>
        </div>
        <div className="stat-card">
          <h3>5,000+</h3>
          <p>Active Users</p>
        </div>
        <div className="stat-card">
          <h3>98%</h3>
          <p>Success Rate</p>
        </div>
      </div>
    </section>

    {/* Testimonials Section */}
    <section className="testimonials">
      <h2>What Our Users Say</h2>
      <div className="testimonials-grid">
        <div className="testimonial-card">
          <p>"I found my laptop the same day. The filters made it super fast to narrow down."</p>
          <h4>- Priya M.</h4>
        </div>
        <div className="testimonial-card">
          <p>"Posting a found phone was simple, and the owner verified it quickly. Great experience."</p>
          <h4>- Daniel K.</h4>
        </div>
        <div className="testimonial-card">
          <p>"Love the built‑in chat — no need to share my number. Felt safe from start to finish."</p>
          <h4>- Laila A.</h4>
        </div>
      </div>
    </section>

    {/* FAQ Section */}
    <section className="faq">
      <h2>Frequently Asked Questions</h2>
      <div className="faq-item">
        <h3>Do I need an account to search?</h3>
        <p>No — anyone can browse. You’ll only need an account to post or to message others.</p>
      </div>
      <div className="faq-item">
        <h3>How do I prove ownership?</h3>
        <p>Upload receipts, serial numbers or photos. We guide you through in‑app verification.</p>
      </div>
      <div className="faq-item">
        <h3>Is Lost &amp; Found free?</h3>
        <p>Yes. Our platform is free to use for everyone.</p>
      </div>
    </section>

    {/* About Section */}
    <section className="about">
      <h2>About Us</h2>
      <p>
        Lost &amp; Found helps communities reunite with what matters — from phones and wallets to cherished
        keepsakes. Our mission is simple: make it effortless to post, search and securely coordinate returns
        while keeping your privacy intact.
      </p>
    </section>

    {/* Call to Action */}
    <section className="cta">
      <h2>Post or Search in Seconds</h2>
      <p>Help reunite an item today — it’s free and takes less than a minute to get started.</p>
      <Link to="/new-item" className="btn btn-primary btn-lg">Post an Item</Link>
    </section>
  </div>
);

export default HomePage;